(() => {
  function init(root=document) {
    root.querySelectorAll('[data-vc-gallery]').forEach(gallery => {
      if(gallery.dataset.ready)return;
      gallery.dataset.ready='true';
      const slides=[...gallery.querySelectorAll('[data-vc-slide]')],thumbs=[...gallery.querySelectorAll('[data-vc-thumb]')];
      let index=0;
      function show(next){index=(next+slides.length)%slides.length;slides.forEach((slide,i)=>slide.hidden=i!==index);thumbs.forEach((thumb,i)=>thumb.setAttribute('aria-pressed',String(i===index)));gallery.querySelector('[data-vc-counter]').textContent=`${index+1} / ${slides.length}`;}
      thumbs.forEach((thumb,i)=>thumb.addEventListener('click',()=>show(i)));
      gallery.querySelector('[data-vc-prev]').addEventListener('click',()=>show(index-1));
      gallery.querySelector('[data-vc-next]').addEventListener('click',()=>show(index+1));
      gallery.addEventListener('keydown',event=>{if(event.key==='ArrowRight'){event.preventDefault();show(index+1)}if(event.key==='ArrowLeft'){event.preventDefault();show(index-1)}});
    });
    root.querySelectorAll('.som-vc-mobile-nav').forEach(menu=>{if(menu.dataset.ready)return;menu.dataset.ready='true';menu.addEventListener('click',e=>{if(e.target.closest('a'))menu.open=false});menu.addEventListener('keydown',e=>{if(e.key==='Escape'){menu.open=false;menu.querySelector('summary').focus()}})});
  }
  init();document.addEventListener('shopify:section:load',e=>init(e.target));
})();
